export default {"src":"/_next/static/media/GLOBE.19733b53.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};